export default {
  label: 'Label',
  labelEn: 'LabelEn',
  icon: 'Icon',
  router: 'Router',
  sort: 'Sort',
  rule: 'Rule',
  catalog: 'Catalog',
  menu: 'Menu',
  button: 'Button',
  parentMenu: 'Parent Menu',
  addChildMenu: 'Add a new level',
  helpIcon:
    'Click the question mark to jump to the icon query, and after the query, pass the icon name value into the input box',
  changeState: 'Switch state',
  changeStateMsg: 'Do you want to change {{name}} to [{{state}}] state?',
};
